export interface IEndpoints {
	search: string,
}

export interface IFilter {
	categories: string[]
}

export interface ISearchResultItem {
	title: string,
	id: string,
	url: string,
	type: string,
	description: string,
	isAttraction: boolean,
	date: string | boolean,
	size: string | boolean,
	categories: string[],
	image: string | boolean,
	location: string | boolean,
}

export interface ISearchResult {
	items: ISearchResultItem[],
	query: string,
	count: number,
	page: number,
	filter: IFilter,
	total: number,
	canLoadMore: boolean,
}

export interface IState {
	searchResult: ISearchResult,
	endpoints: IEndpoints,
	translations: Object,
	categories: string[],
	loading: boolean,
}

const deafultState: IState = {
	searchResult: {
		items: [],
		query: '',
		count: 0,
		page: 1,
		filter: {
			categories: []
		},
		total: 0,
		canLoadMore: false,
	},
	endpoints: {
		search: ''
	},
	translations: {},
	categories: [],
	loading: false,
}

export default deafultState;
